// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Xtdm","containerItemsCenter":"Skeleton_containerItemsCenter__9Dd3A"};